import React, { useState } from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";

const ContactForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const productDetails = location.state?.productDetails;
  const [isLoading, setIsLoading] = useState(false);
  const [submitAttempts, setSubmitAttempts] = useState(0);

  const [forms, setForms] = useState({
    name: "",
    email: "",
    subject: "",
    phone: "",
    company: "",
    message: "",
  });

  const [validator] = useState(
    new SimpleReactValidator({ className: "errorMessage" })
  );

  const changeHandler = (e) => {
    setForms({ ...forms, [e.target.name]: e.target.value });
    validator.showMessageFor(e.target.name);
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    
    if (validator.allValid()) {
      setIsLoading(true);
      setSubmitAttempts(prev => prev + 1);
      
      try {
        // Set up request headers
        const headers = {
          'Content-Type': 'application/json',
        };
        
        // Send data as JSON
        const response = await fetch("https://replicaindia.com/maincontact.php", {
          method: "POST",
          headers: headers,
          body: JSON.stringify(forms),
        });

        console.log("Response status:", response.status);
        
        // Check response type
        const contentType = response.headers.get("content-type");
        
        if (contentType && contentType.includes("text/html")) {
          // Handle HTML response (possibly a security page)
          const html = await response.text();
          console.log("Received HTML response");
          
          // if (html.includes("document.cookie") && html.includes("reload")) {
          //   // CloudFlare or similar security check
          //   console.log("Security check detected, waiting...");
            
          //   if (submitAttempts < 3) {
          //     toast.info("Processing your request...");
          //     setTimeout(() => submitHandler(e), 3000);
          //     return;
          //   } else {
          //     throw new Error("Security verification failed after multiple attempts");
          //   }
          // }
          
          // If we get HTML but not security check, assume success
          toast.success("Form submitted successfully");
          navigate('/');
          resetForm();
        } else {
          // Handle JSON response
          let data;
          try {
            data = await response.json();
            console.log("Received response data:", data);
          } catch (e) {
            console.error("Failed to parse JSON:", e);
            
            // Check if the request was actually successful despite parsing error
            if (response.ok) {
              toast.success("Form submitted successfully");
              navigate('/');
              resetForm();
              return;
            } else {
              throw new Error("Invalid response format");
            }
          }
          
          // Process the parsed JSON response
          if (data.status === "success") {
            toast.success(data.message || "Successfully we got your info.");
            navigate('/');
            resetForm();
          } else if (data.errors) {
            // Show individual validation errors
            Object.entries(data.errors).forEach(([field, message]) => {
              toast.error(`${field}: ${message}`);
            });
          } else if (response.status === 409) {
            // Handle conflict error specifically
            toast.info(data.message || "Your form was already submitted. Please wait before submitting again.");
            navigate('/');
            resetForm();
          } else {
            // Generic error handling
            toast.error(data.message || "An error occurred. Please try again.");
          }
        }
      } catch (error) {
        console.error("Submission error:", error);
        toast.error("Unable to submit form. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    } else {
      validator.showMessages();
      toast.error("Please complete all required fields correctly.");
    }
  };

  const resetForm = () => {
    setForms({
      name: "",
      email: "",
      subject: "",
      phone: "",
      company: "",
      message: "",
    });
    
    // Reset validator and attempt counter
    validator.hideMessages();
    setSubmitAttempts(0);
  };

  return (
    <form onSubmit={submitHandler} className="contact-form">
      <div className="row">
        <div className="col-lg-6">
          <div className="input-field">
            <label htmlFor="name">Name*</label>
            <div className="input-box">
              <input
                value={forms.name}
                type="text"
                name="name"
                className="form-control"
                onChange={changeHandler}
              />
              {validator.message("name", forms.name, "required|alpha_space")}
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="input-field">
            <label htmlFor="email">Email*</label>
            <div className="input-box">
              <input
                value={forms.email}
                type="email"
                name="email"
                className="form-control"
                onChange={changeHandler}
              />
              {validator.message("email", forms.email, "required|email")}
            </div>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="input-field">
            <label htmlFor="phone">Phone*</label>
            <div className="input-box">
              <input
                value={forms.phone}
                type="text"
                name="phone"
                className="form-control"
                onChange={changeHandler}
              />
              {validator.message("phone", forms.phone, "required|phone")}
            </div>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="input-field text-field">
            <label htmlFor="message">Message</label>
            <div className="input-box">
              <textarea
                onChange={changeHandler}
                value={forms.message}
                name="message"
                className="form-control"
                placeholder="How can we help you?"
              />
              {validator.message("message", forms.message, "required")}
            </div>
          </div>
        </div>
      </div>
      <div className="cp-det-btn mt-20 d-grid">
        <button
          type="submit"
          name="submit"
          disabled={isLoading}
          className={isLoading ? "loading" : "cp-btn"}
        >
          {isLoading ? (
            <>
              <Spin indicator={<LoadingOutlined spin />} />
              <span style={{ marginLeft: "8px" }}>Submitting...</span>
            </>
          ) : (
            <>
              Send us a message <i className="fal fa-arrow-right"></i>
            </>
          )}
        </button>
      </div>
    </form>
  );
};

export default ContactForm;